import React, { useEffect, useState } from "react";

// JS Files
import { APP_API_URL } from "../../constants/constants";

// Others File
import MobileImg from "../../imgs/banner-1.svg";
import downloadIcon from "../../imgs/banner-download.svg";
import giudeIcon from "../../imgs/banner-guide.svg";
import radarImg from "../../imgs/banner-radar.svg";

const Banner = () => {
  const [apklinks, setApkLinks] = useState({ customer_app: null });
  useEffect(() => {
    // GET request using fetch inside useEffect React hook
    fetch(`${APP_API_URL}/api/app/commons/app_link/?insurance_code=REF`)
      .then((response) => response.json())
      .then((data) => setApkLinks(data));
  }, []);
  return (
    <>
      <div className="my-8 md:mx-20 flex flex-col md:flex-row bg-[#FA8443] md:rounded-xl">
        <div className="bg-[#FFD1B8] basis-1/4 p-2 md:px-2 flex items-end justify-center rounded-b-[12rem] md:rounded-l-[12rem] md:rounded-r-xl">
          <img src={MobileImg} className="w-3/4 md:w-full" />
        </div>
        <div className="bg-[#FA8443] basis-3/4 md:rounded-l-xl relative   p-4 md:p-8 w-full">
          <img src={radarImg} className="banner-rader" />
          <div className="flex flex-col items-center justify-center ">
            <span
              className="text-2xl md:text-3xl px-4 text-center text-white"
              style={{ fontFamily: "lale" }}
            >
              اعلام خسارت اتومبیل، درمان و حوادث دانش‌آموزی و درخواست خرید بیمه
            </span>
            <span
              className="text-2xl md:text-3xl px-4 text-center text-white mt-4"
              style={{ fontFamily: "lale" }}
            >
              با استفاده از اپلیکیشن رفاپ
            </span>
            <span
              className="text-lg md:text-xl px-4 text-center text-white mt-12"
              style={{ fontFamily: "lale" }}
            >
              برای دریافت اپلیکیشن رفاپ و مشاهده راهنمای استفاده از آن اقدام
              کنید.
            </span>
            <div className="flex flex-col md:flex-row justify-center md:justify-between mt-8">
              <div
                className="border-2 border-[#61BED7] rounded-lg cursor-pointer bg-white md:ml-4 p-2 h-16 md:h-auto md:w-64 flex justify-center items-center transition-all hover:bg-slate-50"
                onClick={() =>
                  window.open("https://www.aparat.com/v/cVrth", "_blank")
                }
              >
                <img src={giudeIcon} className="ml-2" />
                <span className="font-bold text-[#505050] mr-2">
                  راهنمای استفاده از اپلیکیشن
                </span>
              </div>
              <div
                className="border-2 border-[#61BED7] rounded-lg cursor-pointer bg-white md:mr-4 p-2 h-16 md:h-auto md:w-64 mt-4 md:mt-0  flex justify-center items-center transition-all hover:bg-slate-50"
                onClick={() => window.open(apklinks?.customer_app, "_blank")}
              >
                <img src={downloadIcon} className="ml-2" />
                <span className="font-bold text-[#505050] mr-2">
                  دریافت اپلیکیشن رفاپ
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Banner;
